export const FETCH_USERS_REQUEST = "FETCH_USERS_REQUEST";
export const FETCH_USERS_SUCCESS = "FETCH_USERS_SUCCESS";
export const FETCH_USERS_FAILURE = "FETCH_USERS_FAILURE";

export const ADD_UPDATE_USER_REQUEST = "ADD_UPDATE_USER_REQUEST";
export const ADD_UPDATE_USER_SUCCESS = "ADD_UPDATE_USER_SUCCESS";
export const ADD_UPDATE_USER_FAILURE = "ADD_UPDATE_USER_FAILURE";

export const SET_LOGGED_IN_USER_REQUEST = "SET_LOGGED_IN_USER_REQUEST";

export const RESET_ON_LOGOUT = "RESET_ON_LOGOUT";
